namespace app.tarefas {
    'use strict';
    
    import ITranslatePartialLoaderProvider = angular.translate.ITranslatePartialLoaderProvider;
    import IStateProvider = angular.ui.IStateProvider;

    /** @ngInject * */
    function config($translatePartialLoaderProvider: ITranslatePartialLoaderProvider,
                    $stateProvider: IStateProvider,
                    msNavigationServiceProvider: any) {
        $translatePartialLoaderProvider.addPart('app/main/tarefas');
        $stateProvider.state('app.tarefas', {
            abstract: true,
            url: '/tarefas',
            parent: 'app.autenticado'
        });

        // Navigation
        msNavigationServiceProvider.saveItem('tarefas', {
            title: 'TAREFAS',
            translation: 'TAREFAS.TAREFAS',
            group: true,
            weight: 2
        });
    }

    /** @ngInject */
    function run(stfBreadcrumbsService: app.support.StfBreadcrumbsService, 
		$rootScope: ng.IRootScopeService,
		messagesService: app.support.messaging.MessagesService, 
		$state: ng.ui.IStateService,
		$log: ng.ILogService, 
		msNavigationService,
		) {
        stfBreadcrumbsService.registerPath({
            id: 'tarefas',
            translation: 'Tarefas',
            uisref: 'app.tarefas.minhas-tarefas'
        });

        $rootScope.$on("$stateChangeStart", (event, toState, toParams, fromState, fromParams, options) => {
            if (toState.name.startsWith("app.tarefas")) {
                if (toParams.hasOwnProperty("task") && toParams["task"] === undefined) {
                    event.preventDefault();
                    messagesService.error("Tarefa não encontrada.");
                    $state.go("app.tarefas.minhas-tarefas");
                }
            }
        });
        msNavigationService.sort();

        $rootScope.$on('$stateChangeError', (event, toState, toParams, fromState, fromParams, error) => {
            if (toState.name.startsWith("app.tarefas")) {
                messagesService.error("Erro ao acessar a tarefa.");
                $rootScope["loadingProgress"] = false;
            }
			$log.error(error);
        });
    }

    angular
        .module('app.tarefas', ['app.autenticado', 'app.support'])
        .config(config)
        .run(run);
}